/* eslint-disable consistent-return */
import { useEffect, useState, useReducer } from 'react'

const initState = {
  res: null,
  pending: false,
  error: false,
  complete: false,
  load: false,
}

const epDataReducer = (state, { type, res, err }) => {
  const change = { ...state }
  switch (type) {
    case 'pending':
      change.pending = true
      change.complete = false
      change.error = null
      break
    case 'complete':
      change.res = res.data
      change.pending = false
      change.complete = true
      change.load = false
      break
    case 'load':
      change.load = true
      break
    case 'error':
      change.error = err
      change.complete = true
      change.pending = false
      change.load = false
      break
    default:
      break
  }

  return { ...change }
}

export default (endpointFunction) => {
  const [epState, epDispatch] = useReducer(epDataReducer, initState)
  const [args, setArgs] = useState()
  const funcReturn = (...newArgs) => {
    setArgs(newArgs)
  }

  useEffect(() => {
    let subscribe = true
    if (!args) return
    epDispatch({ type: 'pending' })
    endpointFunction(...args)
      .then((res) => {
        if (subscribe) epDispatch({ type: 'complete', res })
      })
      .catch((err) => {
        if (subscribe) epDispatch({ type: 'error', err })
      })

    return () => {
      subscribe = false
    }
  }, [args, endpointFunction])

  return [epState, epDispatch, funcReturn]
}
